export enum BookablePersonDuplicateDecision {
  Match = 'Match',
  Mismatch = 'Mismatch',
  Review = 'Review',
}
